import { render, staticRenderFns } from "./add-payments-dialog.vue?vue&type=template&id=61e10c3f&scoped=true&"
import script from "./add-payments-dialog.vue?vue&type=script&lang=js&"
export * from "./add-payments-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-payments-dialog.vue?vue&type=style&index=0&id=61e10c3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e10c3f",
  null
  
)

export default component.exports